import React, { useState, useEffect } from "react";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import companyBookingApiService from "../../../../services/companyBookingApis";
import appController from "../../../controller/appController";
import locationService from "../../../../services/locationService";
import { useHistory } from "react-router-dom";

function PayMentForm({ state, updateState, setValue }) {
  const stripe = useStripe();
  const elements = useElements();
  const [paymentError, setPaymentError] = useState("");
  const [error, setError] = useState("");
  const history = useHistory();
  const mounted = React.useRef(true);

  const bookingDetails = () => {
    updateState({ paymentMode: false });
  };

  useEffect(() => {
    return () => {
      mounted.current = false;
    };
  }, []);

  const safeSetState = (callback) => {
    if (mounted.current) {
      callback();
    }
  };

  function validatePhoneNumber(phoneNumber) {
    try {
      const phonePattern = /^\d{10}$/;
      return phonePattern.test(phoneNumber);
    } catch (err) {
      console.log(err, "error");
    }
  }

  const validation = () => {
    let mandatoryFields = ["firstName", "lastName", "emailId", "phoneNo"];
    if (state.paymentType === "Card Payment") {
      mandatoryFields.push("cardHolderName");
    } else {
      mandatoryFields.push("corporateCode");
    }
    try {
      let errors = [];
      for (let field of mandatoryFields) {
        if (!state[field] || state[field].trim() === "") {
          $("#" + field).addClass("validation");
          errors.push(field);
        } else {
          $("#" + field).removeClass("validation");
        }
      }

      if (!state.emailId || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(state.emailId)) {
        console.log("hello");

        $("#emailId").addClass("validation");
        errors.push("emailId");
      } else {
        $("#emailId").removeClass("validation");
      }
      if (!state.termsCheck) {
        $("#termsCheck").addClass("validation");
        errors.push("termsCheck");
      } else {
        $("#termsCheck").removeClass("validation");
      }
      // Phone Number Validation using intlTelInput
      let phoneInput = $("#phoneNo");
      if (!validatePhoneNumber(state.phoneNo)) {
        phoneInput.addClass("validation");
        errors.push("phoneNo");
      } else {
        phoneInput.removeClass("validation");
      }

      return errors.length > 0 ? false : true;
    } catch (error) {
      console.log(error, "error");

      // handleError(error);
    }
  };

  function handleCheck() {
    // $("#paymentErrorModal").modal("show");
    updateState({
      termsCheck: !state.termsCheck,
    });
  }

  const dailyRentCalculation = () => {
    // let lastDueDate = state.newInvoiceList[state.newInvoiceList.length - 1];
    let dailyRent = Number(state.fullStayAmount) / state.totalStayDays;
    let days = state.totalStayDays <= 30 ? state.totalStayDays : 30;
    console.log(dailyRent, "dailyRent", dailyRent * days);
    return dailyRent;
  };

  const handleSubmit = async () => {
    console.log("hello");
    updateState({ buttonLoader: true });
    setPaymentError("");
    try {
      let isValid = validation();
      console.log(isValid, "isValid");

      if (!isValid) {
        updateState({ buttonLoader: false });
        console.log("Form validation failed.");
        return;
      }

      const countryCode =
        $(".country.highlight.active").attr("data-dial-code") == undefined
          ? "+1"
          : "+" + $(".country.highlight.active").attr("data-dial-code");
      const countrySymbol =
        $(".country.highlight.active").attr("data-country-code") == undefined
          ? "us"
          : $(".country.highlight.active").attr("data-country-code");

      updateState({
        countryCode: countryCode,
        countrySymbol: countrySymbol,
      });
      const phonenumber = appController.formatPhoneNumber(
        state.phoneNo == "" ? "" : state.phoneNo
      );
      let paymentMethod;
      let clientId;

      if (state.paymentType == "Card Payment") {
        const card = elements.getElement(CardElement);

        const { token, error } = await stripe.createToken(card);
        // console.log(token, "result");

        if (error) {
          updateState({ buttonLoader: false });
          setPaymentError(error.message);
          return;
        }
        paymentMethod = token;
        updateState({ stripeToken: paymentMethod.id });
        setPaymentError("");
      } else {
        let reqObject = {
          corporatecode: state.corporateCode,
        };
        let response = await companyBookingApiService.checkCorporateCode(
          reqObject
        );
        if (response.IsCodeExists == true && response.error == 0) {
          clientId = response.clientId;
          setPaymentError("");
          updateState({
            clientId: response.clientId,
            stripeToken: "",
          });
        } else {
          updateState({ buttonLoader: false, stripeToken: "" });
          setPaymentError(response.message);
          return;
        }
        // console.log(response, "response", response.clientId);
      }

      // let lastDueDate = state.newInvoiceList[state.newInvoiceList.length - 1];
      // console.log(lastDueDate, "lastDueDate");
      let dailyRent = dailyRentCalculation();

      const bookingRequest = {
        //Guest Data
        checkin: moment(state.checkin).format("MM-DD-YYYY"),
        checkout: moment(state.checkout).format("MM-DD-YYYY"),
        resident_firstname: state.firstName == "" ? "" : state.firstName,
        resident_lastname: state.lastName == "" ? "" : state.lastName,
        resident_middlename: "",
        resident_email: state.emailId == "" ? "" : state.emailId,
        resident_phone: phonenumber,
        countrycode: countryCode,
        airline: "",
        flight: "",
        arrivalairport: "",
        ArrivalDate: "",
        travelnotes: "",
        billingaddress: "",
        billing_city: "",
        billing_state: "",
        billing_zip: "",
        ArrivalTime: "",
        //community
        community_id: state.communityData.community_id,
        communityName: state.communityData.community_name,
        city_name: state.communityData.city_name,
        communityAddress: state.communityData.address,
        master_id: state.communityData.masterId,
        radius: 0,
        record_limit: 0,
        latitude: state.communityData.latitude,
        longitude: state.communityData.longitude,
        program: ["SA Web"],
        Checkouttime: "10:00 AM",
        checkintime: "11:59 PM",
        dailyrate: Number(dailyRent),
        roomsize: state.communityData.suite,
        //Card and Amount
        subToltal: Number(state.totalStayAmount).toFixed(2),
        tax: 0,
        invoiceamount: Number(state.totalStayAmount).toFixed(2),
        // sourcetokenid: "",
        sourcetokenid:
          state.paymentType == "Card Payment" ? paymentMethod.id : "",
        clientId: state.paymentType == "Corporate Code" ? clientId : "",
        //Reserved By
        source: "AGE",
        changedby: state.emailId,
        reservedby: "Ashok K",
        reservedbyemail: state.emailId,
        todays: false,
        notify: "",
        phoneNo: state.phoneNo == "" ? "" : countryCode + " " + state.phoneNo,
        //  payment mode and last due date
        payment_enable: state.paymentType == "Card Payment" ? true : false,
        funstuffitems: [
          {
            itemname: "MoveOutCleaningFee",
            onetimefee: true,
            deliverydate: moment(state.checkout).format("MM/DD/YYYY"),
            billtodate: moment(state.checkout).format("MM/DD/YYYY"),
            frequency: "D",
            rate: Number(state.cleaning),
          },
        ],
      };

      console.log(bookingRequest, "bookingRequest");

      let requestObject = {
        master_id: state.communityData.masterId,
        checkin: state.checkin,
        checkout: state.checkout,
      };
      // console.log(requestObject, "requestObject");

      let response = await locationService.checkMasterAvailability(
        requestObject
      );

      if (response.error == "0") {
        setPaymentError("");
        await confrimPayment(bookingRequest);
      } else {
        updateState({ buttonLoader: false });
        setError(response.message);
        $("#paymentErrorModal").modal("show");
        // setPaymentError(response.message);
      }
    } catch (error) {
      setPaymentError("");
      updateState({ buttonLoader: false });
      console.log(error, "error payment");
    }
  };

  const handleKeyDown = (e) => {
    // Prevent special characters from being entered
    if (
      !/^[a-zA-Z0-9-_]$/.test(e.key) &&
      e.key !== "Backspace" &&
      e.key !== "Delete" &&
      e.key !== "ArrowLeft" &&
      e.key !== "ArrowRight" &&
      e.key !== "Tab"
    ) {
      e.preventDefault();
    }
  };

  const confrimPayment = async (requestObject) => {
    try {
      const response = await companyBookingApiService.CreateStripeOrder(
        requestObject
      );
      // console.log(response, "response");
      if (mounted.current) {
        if (response.error == "0") {
          console.log("if statement");

          if (state.paymentType === "Card Payment" && elements) {
            const cardElement = elements.getElement(CardElement);
            if (cardElement) {
              cardElement.clear();
            }
          }

          history.push("/bookingConfirmed", { orderId: response.orderId });

          safeSetState(() => {
            setPaymentError("");
            updateState({
              stripeToken: "",
              clientId: "",
              firstName: "",
              lastName: "",
              emailId: "",
              cardHolderName: "",
              corporateCode: "",
              phoneNo: "",
              paymentType: "Card Payment",
              companyName: "",
              buttonLoader: false,
            });
          });
        }
        //  else if (response.error == "1" && response.orderId != "") {
        //   console.log(" else if statement");
        //   if (state.paymentType === "Card Payment" && elements) {
        //     const cardElement = elements.getElement(CardElement);
        //     if (cardElement) {
        //       cardElement.clear();
        //     }
        //   }

        //   history.push("/bookingConfirmed", {
        //     orderId: response.orderId,
        //     message: response.message,
        //   });

        //   safeSetState(() => {
        //     setPaymentError("");
        //     updateState({
        //       stripeToken: "",
        //       clientId: "",
        //       firstName: "",
        //       lastName: "",
        //       emailId: "",
        //       cardHolderName: "",
        //       corporateCode: "",
        //       phoneNo: "",
        //       paymentType: "Card Payment",
        //       companyName: "",
        //       buttonLoader: false,
        //     });
        //   });
        // }
        else {
          console.log("else statement");
          safeSetState(() => {
            updateState({ buttonLoader: false });
            setError(response.message);
          });
          $("#paymentErrorModal").modal("show");
        }
      }
    } catch (error) {
      console.log(error, "error");
      if (mounted.current) {
        safeSetState(() => {
          updateState({ buttonLoader: false });
        });
      }
    }
  };

  return (
    <>
      <form role="form" method="post" className="payment-form guest-form">
        <div className="row">
          <div className="col-md-12 col-lg-6 col-sm-12">
            <div className="form-group ">
              <label className="form-label">Type Of Payment</label>
              <select
                className="form-control"
                value={state.paymentType}
                onChange={(e) => updateState({ paymentType: e.target.value })}
              >
                {/* <option value={""} disabled>
                Select Payment Type{" "}
              </option> */}
                <option value={"Card Payment"}>Card Payment </option>
                {/* <option value={"Corporate Code"}>Corporate Code </option> */}
              </select>
            </div>
            {state.paymentType == "Corporate Code" && (
              <div className="form-group">
                <label for="cname" className="form-label">
                  Corporate Code
                </label>
                <input
                  type="text"
                  id="corporateCode"
                  className="form-control"
                  value={state.corporateCode}
                  onKeyDown={handleKeyDown}
                  placeholder="Corporate Code"
                  onChange={(e) => setValue("corporateCode", e)}
                />
              </div>
            )}
            {state.paymentType == "Card Payment" && (
              <>
                <div className="form-group ">
                  <label for="cinfo" className="form-label">
                    Card information
                  </label>
                  <div className="input-addon">
                    {" "}
                    <CardElement />{" "}
                  </div>
                </div>

                <div className="form-group ">
                  <label for="ncard" className="form-label">
                    Name on card{" "}
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="cardHolderName"
                    value={state.cardHolderName}
                    placeholder=" Name on card *"
                    onChange={(e) => setValue("cardHolderName", e)}
                  />
                </div>
              </>
            )}
            <div className="d-flex align-items-center mb-3 terms-conditionsCheckBox">
              <label className="customCheck">
                <input
                  className="form-control m-0"
                  type="checkbox"
                  id="termsCheck"
                  name="checkbox"
                  onChange={handleCheck}
                  checked={state.termsCheck}
                />
                <span className="checkmark"></span>
              </label>

              <span className="mrg-left-10">
                Agree to{" "}
                <a
                  className="fw-500 text-underline"
                  target="_blank"
                  href="/paymentTerms"
                >
                  {" "}
                  Terms and Conditions
                </a>
              </span>
            </div>

            {/* {state.stripeToken ? (
              <span
                id="stripe-token-generated"
                className="alert alert-success d-block"
              >
                Token: {state.stripeToken}
              </span>
            ) : null} */}
            {paymentError ? (
              <span
                id="stripe-error-generated"
                className="alert alert-danger d-block"
              >
                {paymentError}
              </span>
            ) : null}

            {state.paymentType != "" && (
              <div className="form-group">
                {state.buttonLoader ? (
                  <span
                    style={{
                      fontSize: 20,
                      textAlign: "center",
                      display: "block",
                    }}
                  >
                    <i className="fa fa-spinner fa-spin" /> please wait ...!
                  </span>
                ) : (
                  <button
                    className="btn btn-continue w-100"
                    type="button"
                    onClick={() => handleSubmit()}
                  >
                    {state.paymentType == "Card Payment"
                      ? `Due Today ${state.totalStayAmount}`
                      : "Submit"}
                  </button>
                )}
              </div>
            )}
          </div>
        </div>
      </form>

      <div
        className="modal fade"
        id="paymentErrorModal"
        role="dialog"
        data-backdrop="static"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header border-0 p-0">
              <button type="button" className="close" data-dismiss="modal">
                <i className="bi bi-x"></i>
              </button>
            </div>
            <div className="modal-body">
              <p className="alert-warning" style={{ textAlign: "center" }}>
                <i className="bi bi-exclamation-triangle"></i>
                {error}
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default PayMentForm;
